<app-film
  name="hero"
  anchor="top"
  label="Little Nap recliners — 3D tour of the range"
  [chapters]="chapters"
  [loader]="loader"
  [actions]="actions"
  [lead]="true"
  [orbit]="true"
  (stageEvent)="onStageEvent($event)"
>
  <ng-template #slideExtra let-chapter>
    @if (chapter.id === 'sofa') {
      <div class="swatches" role="group" aria-label="Fabric colour">
        @for (col of colours; track col.name; let i = $index) {
          <button
            type="button"
            class="swatch"
            [class.is-active]="i === colour()"
            [attr.aria-pressed]="i === colour()"
            (click)="pickColour(i)"
          >
            <span class="swatch__dot" [style.background]="col.hex"></span>
            {{ col.name }}
          </button>
        }
      </div>
    }

    <!-- the model on show in this chapter -->
    <p class="product">
      <a class="product__name" [href]="product(chapter).href" target="_blank" rel="noopener">
        {{ product(chapter).name }}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7M9 7h8v8" /></svg>
      </a>
      @if (product(chapter).price; as price) {
        <strong>{{ price }}</strong>
        <s>{{ product(chapter).mrp }}</s>
      }
    </p>
  </ng-template>
</app-film>
